var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"blue darken-4"},[_c('router-view',{staticClass:"px-0 py-0"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }